module.exports = __webpack_public_path__ + "img/mlh_ls6.836fdda5.png";